var ClosestDivision, Geocoder, Location, SearchBar, SearchBarView, base, base1, base2, setTranslations;

SearchBarView = require('./views/search_bar');

Location = require('../../../../../src/frontend/helper/search/helper/m_location_helper');

ClosestDivision = require('../../../../../src/frontend/helper/search/common/m_closest_division');

setTranslations = require('../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee').setTranslations;

Geocoder = require('../../../../../src/frontend/helper/search/common/m_geocoder');

module.exports = SearchBar = {
  Autocomplete: {},
  init: function(options) {
    var $searchBar;
    SearchBar.GOOGLE_GEO_URL = options.google_geo_url;
    Location.setDivision(options.division);
    setTranslations(Groupon.LS.translations);
    if (($searchBar = $('form#search-bar, form#ls-search-form')).length) {
      return new SearchBarView({
        $el: $searchBar
      });
    }
  }
};

$(function() {
  var searchConfig;
  if ((searchConfig = Groupon.Modules.SearchBar.Config)) {
    return Groupon.Modules.SearchBar.init(searchConfig);
  }
});

if ((base = window.Groupon).Utils == null) {
  base.Utils = {};
}

_.extend(Groupon.Utils, {
  ClosestDivision: ClosestDivision,
  Geocoder: Geocoder
});

if ((base1 = window.Groupon).Modules == null) {
  base1.Modules = {};
}

if ((base2 = window.Groupon.Modules).SearchBar == null) {
  base2.SearchBar = {};
}

_.extend(window.Groupon.Modules.SearchBar, SearchBar);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvbW9kdWxlcy9naWdfYm9keS9oZWFkZXIvc2VhcmNoX2Jhci9mcm9udGVuZC9pbmRleC5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9tb2R1bGVzL2dpZ19ib2R5L2hlYWRlci9zZWFyY2hfYmFyL2Zyb250ZW5kL2luZGV4LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLGFBQUEsR0FBZ0IsT0FBQSxDQUFRLG9CQUFSOztBQUNoQixRQUFBLEdBQVcsT0FBQSxDQUFRLG9FQUFSOztBQUNYLGVBQUEsR0FBa0IsT0FBQSxDQUFRLHFFQUFSOztBQUNqQixrQkFBbUIsT0FBQSxDQUFRLDRFQUFSOztBQUNwQixRQUFBLEdBQVcsT0FBQSxDQUFRLDZEQUFSOztBQUdYLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLFNBQUEsR0FBWTtFQUMzQixZQUFBLEVBQWMsRUFEYTtFQUczQixJQUFBLEVBQU0sU0FBQyxPQUFEO0FBQ0osUUFBQTtJQUFBLFNBQVMsQ0FBQyxjQUFWLEdBQTJCLE9BQU8sQ0FBQztJQUNuQyxRQUFRLENBQUMsV0FBVCxDQUFxQixPQUFPLENBQUMsUUFBN0I7SUFDQSxlQUFBLENBQWdCLE9BQU8sQ0FBQyxFQUFFLENBQUMsWUFBM0I7SUFFQSxJQUFHLENBQUMsVUFBQSxHQUFhLENBQUEsQ0FBRSxzQ0FBRixDQUFkLENBQXdELENBQUMsTUFBNUQ7YUFDTSxJQUFBLGFBQUEsQ0FBYztRQUNoQixHQUFBLEVBQUssVUFEVztPQUFkLEVBRE47O0VBTEksQ0FIcUI7OztBQWM3QixDQUFBLENBQUUsU0FBQTtBQUNBLE1BQUE7RUFBQSxJQUFHLENBQUMsWUFBQSxHQUFlLE9BQU8sQ0FBQyxPQUFPLENBQUMsU0FBUyxDQUFDLE1BQTFDLENBQUg7V0FDRSxPQUFPLENBQUMsT0FBTyxDQUFDLFNBQVMsQ0FBQyxJQUExQixDQUErQixZQUEvQixFQURGOztBQURBLENBQUY7OztNQUljLENBQUMsUUFBUzs7O0FBQ3hCLENBQUMsQ0FBQyxNQUFGLENBQVMsT0FBTyxDQUFDLEtBQWpCLEVBQXdCO0VBQ3RCLGlCQUFBLGVBRHNCO0VBRXRCLFVBQUEsUUFGc0I7Q0FBeEI7OztPQUtjLENBQUMsVUFBVzs7OztPQUNKLENBQUMsWUFBYTs7O0FBQ3BDLENBQUMsQ0FBQyxNQUFGLENBQVMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsU0FBaEMsRUFBMkMsU0FBM0MifQ==
